<template>
	<div>
		<div class="row"
		     v-if="userInAssistance.email">
			<div class="col-lg-12">
				<h1>Sei nell'account
					<strong>{{userInAssistance.email}}</strong>
				</h1>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-7">
				<Search v-if="!userInAssistance.email" />
				<div class="row mt-4 mb-5 mx-1"
				     v-if="userInAssistance.email">

					<div class="col-lg-12  "
					     style="background-color:#dbfadb">
						<ul class="mt-3">
							<li>
								<a href="#"
								   @click="checkAssistance({email: 'realestatepro@alfiobardolla.com', password: 'sorelsorel'})">
									<strong>ENTRA</strong>
									nel suo account</a>
							</li>
							<li>
								<a href="#"
								   @click="removeAssistance()">esci dal suo account</a>
							</li>
						</ul>
					</div>
				</div>
				<CreateTask v-if="userInAssistance.email"
				            :userInAssistance="userInAssistance" />
			</div>

			<div class="col-lg-5">
				<TaskList :userInAssistance="userInAssistance"
				          :taskListData="taskListData" />
			</div>

		</div>

	</div>
</template>

<script>
	import Search from '@/partials/supercoach/search'
	import TaskList from '@/partials/supercoach/taskList'
	import CreateTask from '@/partials/supercoach/createTask'
	import { mapState, mapActions } from 'vuex'

	export default {
		created() {
			this.realTimeAssistance()
		},
		components: {
			Search,
			TaskList,
			CreateTask,
		},
		computed: {
			...mapState('n_supercoach', ['userInAssistance', 'taskListData', 'formData']),
		},
		methods: {
			...mapActions('n_supercoach', [
				'taskList',
				'realTimeAssistance',
				'activeAssistance',
				'removeAssistance',
				'checkAssistance',
			]),
		},
	}
</script>
